












































import { Component, Prop } from 'vue-property-decorator';

import Edit from '@/layouts/Edit';
import EditBlock from '@/views/CRUD/Edit.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import CPBtn from '@/components/buttons/CPBtn/CPBtn.vue';

import PatientEntityModule from '@/store/patients/entity';
import UserModule, { RoleEnum } from '@/store/user';

import { editTabsNav } from "@/store/patients/tabs";
import { strings } from '@/lib/stringConst';

const PatientIsActiveEnum = {
    YES: 'Пользователь активен',
    NO: 'Пользователь не активен',
}

@Component({
    components: {
        Edit,
        EditBlock,
        TitleReturn,
        CPBtn,
    },
})
export default class PatientsEditLayout extends Edit {
    @Prop({ default: false }) readonly!: boolean;
    @Prop({ default: false }) isPatientActive!: boolean;

    text = strings;
    profile = null;

    get pageEditTitle() {
        return this.isPatientActive ? PatientIsActiveEnum.YES : PatientIsActiveEnum.NO
    }

    get isSuperAdmin() {
        return UserModule.role === RoleEnum.ROLE_SUPER_ADMIN;
    }

    get tabsNav() {
        return editTabsNav;
    }

    get showTitle() {
        return this.currentTab !== 'loyalty_cards';
    }

    get currentTab() {
        let pathName = this.$route.name;
        if (pathName == 'patients_loyalty_cards_show') {
            pathName = 'patients_loyalty_cards';
        }

        const tabs = Object.values(this.tabsNav);
        const currentTab = tabs.find(tab => tab.pathName === pathName);

        return currentTab?.id ?? '';
    }

    get patientId() {
        return this.$route.params.patientsId;
    }

    async activate() {
        await PatientEntityModule.activate(this.patientId);
        this.$emit('update:active');
    }

    async deactivate() {
        await PatientEntityModule.deactivate(this.patientId);
        this.$emit('update:active');
    }

    returnBefore() {
        this.$router.push({name: 'patients'});
    }

    async submit() {
        this.$emit('submit');
    }
}
